import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {Application} from "../application";
import {SidebarItemType} from "../state/sidebarItemType";
import * as ko from "knockout";
import { IntercomHelper } from "../common/intercom-helper";

export class ShowSearchBarCommand implements Command {
    constructor(private app: Application) {
    }
    
    type: CommandType = CommandType.ShowSearchBar;
    canExecute = ko.computed(() => {

        let costbook = this.app.state.costbook();
        let estimate = this.app.state.estimate();

        return !(!costbook && !estimate);
        
    });
    
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    
    execute(): JQueryPromise<any> {
                if(!this.canExecute())
            return $.Deferred().reject().promise();

        if(this.app.state.activeSidebarItem() == SidebarItemType.Search) {
            IntercomHelper.moveRight();
            this.app.state.activeSidebarItem(undefined);
        } else {
            IntercomHelper.moveLeft();
            this.app.state.activeSidebarItem(SidebarItemType.Search);
        }

        return $.Deferred().resolve().promise()
    }

    name = "Keyword Search";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/showSearchBarCommand.ts